import axios from 'axios';
import useSWR from 'swr';

import { AddonsData } from '../types/addons';

const ADDONS_ENDPOINT = '/api/addons';
const DEDUPING_INTERVAL = 300000;

export type AddonsResponse = {
  allAddons: AddonsData;
  availableAddons: AddonsData;
  appliedAddons: AddonsData;
  appliedGroupIds: string[];
  appliedAddonIds: string[];
  availableGroupIds: string[];
};

export const addonsFetcher = async ({
  vehicleId,
  dealId,
  contactId,
}: {
  vehicleId: string | number;
  dealId: string | number;
  contactId?: string | number;
}): Promise<AddonsResponse> => {
  const response = await axios.post<AddonsResponse>(ADDONS_ENDPOINT, {
    productId: vehicleId,
    subscriptionId: dealId,
    contactId,
  });

  return response.data;
};

export const useGetAddons = ({
  vehicleId,
  dealId,
  contactId,
}: {
  vehicleId: string | number;
  dealId: string | number;
  contactId?: string | number;
}) => {
  const { data, isLoading, mutate } = useSWR<AddonsResponse>(
    vehicleId && dealId
      ? { key: 'addons', vehicleId, dealId, contactId }
      : null,
    addonsFetcher,
    {
      keepPreviousData: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      errorRetryCount: 0,
      dedupingInterval: DEDUPING_INTERVAL,
    }
  );

  return { data, isLoading, mutate };
};
